import { Component, OnInit } from "@angular/core";
import { MatTableDataSource, MatDialog } from "@angular/material";
import { Operators } from "src/_models/operators";
import { Users } from "src/_models/users";
import { AppService } from "src/_services/app.service";
import { CommonModalComponent } from "src/app/pages/common-dialog-management/common-dialog.component";
import { Router, ActivatedRoute } from "@angular/router";
import { BetConfigReqParams } from "src/_models";
import {
  roleTypeOperator,
  roleTypeSap,
  disableConfigData,
  SapRoles,
} from "src/_constants/roleType";
import { Location } from "@angular/common";

@Component({
  selector: "app-sport-management",
  templateUrl: "./sport-management.component.html",
  styleUrls: ["./sport-management.component.scss"],
})
export class SportManagementComponent implements OnInit {
  sportsDisplayedColumns: string[] = [
    "SportId",
    "SportName",
    "Status",
    "Action",
  ];
  providers: any = [];
  users = new MatTableDataSource<Users>();
  operators = new MatTableDataSource<Operators>();
  operatorData = new MatTableDataSource<any>();
  games = new MatTableDataSource<any>();
  ProviderId: string = "";
  OperatorId: string = "";
  title: string = "Provider Management";
  showOperatorData: boolean = true;
  showSAPData: boolean = true;
  configData;
  count: number = 0;
  sapRoles = SapRoles;
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    if (this.sapRoles.RolexAdmin === this.userRole.role) {
      this.sportsDisplayedColumns = [ "SportId","SportName"]
    }
    this.OperatorId = this.route.snapshot.params.operator;
    this.ProviderId = this.route.snapshot.params.provider;
    this.showOperatorData = roleTypeOperator.includes(this.userRole.role) || this.userRole.role === SapRoles.GroupAdmin;
    this.showSAPData = roleTypeSap.includes(this.userRole.role);
    if (disableConfigData.includes(this.userRole.role)) {
      this.sportsDisplayedColumns = this.sportsDisplayedColumns.filter(
        (item) => item !== "Action"
      );
    }
    if (this.userRole.role === SapRoles.GroupAdmin) {
      this.title = this.OperatorId + " / " + this.title;
    }
    this.getOurProviders();
    this.getSportData(this.OperatorId, this.ProviderId);
  }

  goTo(link) {
    let linkRoute =
      `/administration/providers/${this.OperatorId}/${this.ProviderId}/` + link.SportId;
      this.appService.setSport(link)
    this.router.navigate([linkRoute]);
  }

  goBack = () => {
    this.location.back();
  };

  getSportData = (oid, pid) => {
    try {
      this.appService.getSportCatalogData(oid, pid).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.games = res.sports;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  };

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  onSelectedProvider = (pid) => {
    this.ProviderId = pid;
    this.getSportData(this.OperatorId, pid);
  };

  handleChangeStatus(e, data) {
    let providerid = this.ProviderId;
    if (e.checked) {
      this.appService
        .unBlockSports(this.OperatorId,data.SportId, providerid)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
          this.getSportData(this.OperatorId,this.ProviderId);
        });
    } else {
      this.appService.blockSports(this.OperatorId,data.SportId, providerid).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
        this.getSportData(this.OperatorId, this.ProviderId);
      });
    }
  }

  applyFilter(event) {
    const value = event.target.value;
    this.games.filter = value.trim().toLocaleLowerCase();
  }

  changeStatus = (data) => {
    if (this.showSAPData) {
      try {
        this.appService
          .getOperatorsData({
            ProviderId: this.ProviderId,
            SportId: data.SportId,
            CompetitionId: "",
            EventId: "",
          })
          .subscribe((res) => {
            if (res.status === "RS_OK") {
              this.operatorData.data = res.providers;
              this.dialog.open(CommonModalComponent, {
                backdropClass: "cdk-overlay-transparent-backdrop",
                hasBackdrop: true,
                data: {
                  providersStatus: this.operatorData,
                  title: data.SportName,
                  proStatus: data.status,
                  ProviderId: this.ProviderId,
                  sportId: data.SportId,
                  CompetitionId: "",
                  EventId: "",
                  For: "SAP",
                  code: 0,
                  level: "sport",
                },
              });
            } else if (res.status === "RS_ERROR") {
              this.appService.openErrorBar(res.errorDescription);
            }
          });
      } catch (err) {}
    }
  };
  handleClick(data) {
    const postBody: BetConfigReqParams = {
      ConfigCall: "sport",
      PartnerId: data.partnerId,
      ProviderId: this.ProviderId,
      SportId: data.SportId,
      CompetitionId: "",
      EventId: "",
      OperatorId: this.OperatorId,
    };

    this.dialog.open(CommonModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        ConfigData: null, //
        ConfigCall: null, //
        For: "OP",
        page: "sport",
        OperatorId: this.OperatorId,
        ProviderId: this.ProviderId,
        SportId: data.SportId,
        CompetitionId: "",
        EventId: "",
        apiReqBody: postBody,
      },
    });

    // try {
    //   this.appService.getOperatorConfigData(postBody).subscribe((res) => {
    //     if (res.status === "RS_OK") {
    //       this.configData = res.config;
    //       this.dialog.open(CommonModalComponent, {
    //         backdropClass: "cdk-overlay-transparent-backdrop",
    //         hasBackdrop: true,
    //         data: {
    //           ConfigData: res.config,
    //           ConfigCall: res.level,
    //           page: "sport",
    //           For: "OP",
    //           OperatorId: "",
    //           ProviderId: this.ProviderId,
    //           SportId: data.SportId,
    //           CompetitionId: "",
    //           EventId: "",
    //         },
    //       });
    //     } else if (res.status === "RS_ERROR") {
    //       this.appService.openErrorBar(res.errorDescription);
    //     }
    //   });
    // } catch (err) {}
  }
}
